import { put, takeLatest } from 'redux-saga/effects';

import { ApiResult } from 'common/models';
import { CORE_TEMPLATE_FILE_NAME } from 'common/config';
import { DownloadTemplateService } from './downloadTemplate.service';
import { downloadTemplateActions } from './downloadTemplate.slice';

const downloadFile = function* () {
    const response: ApiResult<Blob> = yield DownloadTemplateService.downloadFile();
    if (response.value) {
        const url = URL.createObjectURL(new Blob([response.value]));
        const link = document.createElement('a');
        link.target = '_blank';
        link.download = CORE_TEMPLATE_FILE_NAME;
        link.href = url;
        link.click();
        yield put({
            type: downloadTemplateActions.downloadFileSuccess.type,
            payload: response.value
        });
    } else {
        yield put({
            type: downloadTemplateActions.downloadFileFailed.type,
            payload: response.errors
        });
    }
};

const downloadFileWatch = function* () {
    yield takeLatest(downloadTemplateActions.downloadFile.type, downloadFile);
};

export { downloadFileWatch };
